{
    "code": 200,
    "msg": "操作成功",
    "data": [
        {
            "paperNo": "S202610292224051014",
            "paperName": "七年级-first-A-教案卷",
            "learningGrade": "A",
            "paperType": "teaching_plan",
            "questionCount": 26,
            "coreKnowledgePoints": [
                {
                    "id": 3659,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>有理数分为：正有理数（正整数、正分数）、零、负有理数（负整数、负分数）</p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:34:21",
                    "updateTime": "2026-09-12 10:36:23",
                    "createBy": "2017560323615408130",
                    "updateBy": 1,
                    "sortNo": null
                },
                {
                    "id": 3665,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>带“+”的也不一定是正数，如：<span data-latex=\"+\\left(-3\\right)\" class=\"math-node\" data-type=\"math\"></span> </p><p>带“-”的也不一定是负数，如：<span data-latex=\"-\\left(-3\\right)\" class=\"math-node\" data-type=\"math\"></span> </p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:36:12",
                    "updateTime": "2026-03-15 16:36:12",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 3663,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>正有理数包含：正整数和正分数</p><p>负有理数包含：负整数和负分数</p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:35:32",
                    "updateTime": "2026-03-18 11:50:32",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 3662,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>零:0既不是正数，也不是负数</p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:35:22",
                    "updateTime": "2026-03-18 11:50:59",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 3666,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>0是整数也是偶数，也是最小的自然数</p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:36:21",
                    "updateTime": "2026-03-15 16:36:21",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 3661,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>负数：小于0的数，如：-6、-70、-16</p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:35:14",
                    "updateTime": "2026-03-18 11:51:55",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 3664,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>相反意义：在某个领域或概念中，两个量在性质、方向或含义上完全相反。如：升高与降低、向左与向右、收入与支出</p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:35:44",
                    "updateTime": "2026-03-18 11:49:38",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 3658,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>有理数: 凡能写成<span data-latex=\"\\frac{q}{p}\" class=\"math-node\" data-type=\"math\"></span>形式且(p,q 为整数且<span data-latex=\"p \\neq 0\" class=\"math-node\" data-type=\"math\"></span>)的数，都是有理数，整数和分数统称有理数.</p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:34:06",
                    "updateTime": "2026-03-18 11:54:17",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 3660,
                    "tenantId": "000000",
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "core",
                    "difficulty": "1",
                    "knowledgePoint": "<p>正数：大于0的数，如：2、0.75、16、<span data-latex=\"\\frac{1}{2}\" class=\"math-node\" data-type=\"math\"></span> </p>",
                    "textbook": 2,
                    "textbookName": null,
                    "knowledgePointJson": null,
                    "knowledgePointQuestions": null,
                    "questionCount": null,
                    "status": "0",
                    "remark": null,
                    "createTime": "2026-03-15 16:35:03",
                    "updateTime": "2026-03-15 17:45:39",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                }
            ],
            "consolidationQuestions": [
                {
                    "id": 4273,
                    "tenantId": "000000",
                    "knowledgePointId": 3659,
                    "questionDetail": "{\"questionContent\":\"<p>有理数分为：________、________、________。</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:53:45",
                    "updateTime": "2026-09-12 10:38:52",
                    "createBy": "2017560323615408130",
                    "updateBy": 1,
                    "sortNo": null
                },
                {
                    "id": 8005,
                    "tenantId": "000000",
                    "knowledgePointId": 3665,
                    "questionDetail": "{\"questionContent\":\"<p><span data-latex=\\\"+（-6）=\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span> </p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-25 11:06:10",
                    "updateTime": "2026-03-25 11:06:10",
                    "createBy": 1,
                    "updateBy": 1,
                    "sortNo": null
                },
                {
                    "id": 4257,
                    "tenantId": "000000",
                    "knowledgePointId": 3665,
                    "questionDetail": "{\"questionContent\":\"<p><span data-latex=\\\"-（-4）=\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span> </p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:49:20",
                    "updateTime": "2026-03-25 11:05:16",
                    "createBy": "2017560323615408130",
                    "updateBy": 1,
                    "sortNo": null
                },
                {
                    "id": 4263,
                    "tenantId": "000000",
                    "knowledgePointId": 3663,
                    "questionDetail": "{\"questionContent\":\"<p>正有理数包含：正整数和____________</p><p>负有理数包含：负整数和____________</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:50:53",
                    "updateTime": "2026-03-18 11:50:53",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4265,
                    "tenantId": "000000",
                    "knowledgePointId": 3662,
                    "questionDetail": "{\"questionContent\":\"<p>零:0既不是________，也不是负数</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:51:15",
                    "updateTime": "2026-03-18 11:51:15",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4264,
                    "tenantId": "000000",
                    "knowledgePointId": 3662,
                    "questionDetail": "{\"questionContent\":\"<p>零:0既不是________，也不是负数</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:51:09",
                    "updateTime": "2026-03-18 14:01:48",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4255,
                    "tenantId": "000000",
                    "knowledgePointId": 3666,
                    "questionDetail": "{\"questionContent\":\"<p>0是整数也是____________，也是最小的自然数</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:48:30",
                    "updateTime": "2026-03-18 11:48:30",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4254,
                    "tenantId": "000000",
                    "knowledgePointId": 3666,
                    "questionDetail": "{\"questionContent\":\"<p>0是整数也是____________，也是最小的自然数</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:48:09",
                    "updateTime": "2026-03-18 11:57:46",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4268,
                    "tenantId": "000000",
                    "knowledgePointId": 3661,
                    "questionDetail": "{\"questionContent\":\"<p>负数：小于________的数</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:52:25",
                    "updateTime": "2026-03-18 11:52:25",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4267,
                    "tenantId": "000000",
                    "knowledgePointId": 3661,
                    "questionDetail": "{\"questionContent\":\"<p>负数：小于________的数</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:52:19",
                    "updateTime": "2026-03-18 11:52:19",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4261,
                    "tenantId": "000000",
                    "knowledgePointId": 3664,
                    "questionDetail": "{\"questionContent\":\"<p>相反意义：在某个领域或概念中，两个量在性质、________或含义上完全相反。</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:50:14",
                    "updateTime": "2026-03-18 11:50:14",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4260,
                    "tenantId": "000000",
                    "knowledgePointId": 3664,
                    "questionDetail": "{\"questionContent\":\"<p>相反意义：在某个领域或概念中，两个量在性质、________或含义上完全相反。</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:50:09",
                    "updateTime": "2026-03-18 11:59:35",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4280,
                    "tenantId": "000000",
                    "knowledgePointId": 3658,
                    "questionDetail": "{\"questionContent\":\"<p>有理数: 凡能写成________形式且(p,q 为整数且<span data-latex=\\\"p \\\\neq 0\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>)的数，都是有理数，整数和________统称有理数.</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:55:25",
                    "updateTime": "2026-03-25 14:49:26",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4279,
                    "tenantId": "000000",
                    "knowledgePointId": 3658,
                    "questionDetail": "{\"questionContent\":\"<p>有理数: 凡能写成________形式且(p,q 为整数且<span data-latex=\\\"p \\\\neq 0\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>)的数，都是有理数，整数和________统称有理数.</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:55:20",
                    "updateTime": "2026-03-18 14:11:45",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4270,
                    "tenantId": "000000",
                    "knowledgePointId": 3660,
                    "questionDetail": "{\"questionContent\":\"<p>正数：大于________的数</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:53:04",
                    "updateTime": "2026-03-18 14:04:00",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                },
                {
                    "id": 4271,
                    "tenantId": "000000",
                    "knowledgePointId": 3660,
                    "questionDetail": "{\"questionContent\":\"<p>正数：大于________的数</p>\"}",
                    "questionDetailJson": null,
                    "createTime": "2026-03-18 11:53:17",
                    "updateTime": "2026-03-18 11:53:17",
                    "createBy": "2017560323615408130",
                    "updateBy": "2017560323615408130",
                    "sortNo": null
                }
            ],
            "learnWithMeQuestions": [
                {
                    "id": 27,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "select",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "example",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>今年全国粮食总产量比去年增长5%了，若“+5%”表示增长5%，则“−35%”表示（　　）</p>\",\"answerContent\":\"<p>A</p>\",\"analysisContent\":\"<p>【分析】本题考查了正负数的应用：根据“+5%”表示增长5%，即可作答。<br>【详解】解：∵“+5%”表示增长5%，<br>∴“-35%”表示减少35%，<br>故选：A</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>减少35%</p>\"},{\"label\":\"B\",\"value\":\"<p>增长35%</p>\"},{\"label\":\"C\",\"value\":\"<p>减少65</p>\"},{\"label\":\"D\",\"value\":\"<p>增长65%</p>\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-09 15:34:04",
                    "updateTime": "2026-09-17 14:14:43",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 1
                },
                {
                    "id": 951,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "select",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "example",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>冰箱是每个家庭的必备家用电器，冰箱冷冻室最佳温度设置在零下18摄氏度，这样既能让食品快速结冻，让食物的保鲜效果更好，又不会让冰箱内部结冰结霜且相对节能．小明在一次节能减排调查实践活动中对全班同学家的冰箱温度调节情况进行了了解，发现其中有四位同学家的冰箱温度设置都不是零下18摄氏度，从最佳的角度看，你认为温度设置相对合理的是（&nbsp;&nbsp;&nbsp;&nbsp;）</p>\",\"answerContent\":\"<p>B</p>\",\"analysisContent\":\"<p>【分析】本题主要考查了正负数的意义，解题的关键是掌握正负数的意义．</p><p>【详解】解：在四个选项中最接近零下18摄氏度的是-19摄氏度，故B正确．</p><p>故选：B．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>-20</p>\"},{\"label\":\"B\",\"value\":\"<p>-19</p>\"},{\"label\":\"C\",\"value\":\"<p>-15</p>\"},{\"label\":\"D\",\"value\":\"<p>-12</p>\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-11 15:29:25",
                    "updateTime": "2026-09-17 14:25:23",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 2
                }
            ],
            "tryPracticeQuestions": [
                {
                    "id": 38,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "select",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "test",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>中国是世界上最早使用负数的国家，战国时期李悝所著的《法经》中已使用负数．如果公元前500年记作-500年，那么公元2023年应记作（　　）</p>\",\"answerContent\":\"<p>C</p>\",\"analysisContent\":\"<p>【分析】根据相反意义的量进行求解即可。</p><p>【详解】解：∵ 公元前 500 年记作 -500 年，∴ 公元前为“-”，∴ 公元后为“+”，<br>∴ 公元 2023 年就是公元后 2023 年，<br>∴ 公元 2023 年应记作 +2023 年。<br>故选：C。</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>-2023年</p>\"},{\"label\":\"B\",\"value\":\"<p>+1523年</p>\"},{\"label\":\"C\",\"value\":\"<p>+2023年</p>\"},{\"label\":\"D\",\"value\":\"<p>+2523年</p>\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-09 16:12:08",
                    "updateTime": "2026-09-17 14:12:27",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 1
                },
                {
                    "id": 141,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "test",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>在下列“______”上填入适当的词，使前后两句话构成具有相反意义的量．</p><p>（1）下降2米，<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>7米；<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>3万元，盈利10万元；</p><p>（2）增加10斤，<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>5斤；零上10℃，<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>9℃．</p>\",\"answerContent\":\"<p>上升，亏损，减少，零下．</p>\",\"analysisContent\":\"<p>【分析】根据相反意义的量的要素“它们的意义相反”填空即可．</p><p>【详解】（1）下降2米，上升7米；亏损3万元，盈利10万元；</p><p>（2）增加10斤，减少5斤；零上10℃，零下9℃．</p><p>故答案为：上升，亏损，减少，零下．</p><p>【点睛】本题考查用正负数表示两种具有相反意义的量包含两个要素：①它们的意义相反；②表示一定的数量．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-10 15:05:09",
                    "updateTime": "2026-09-17 11:21:58",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 1
                }
            ],
            "adaptivePracticeQuestions": [
                {
                    "id": 96,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "select",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "match",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>在表示某地的高度时，通常以海平面为基准，用 0m 表示海平面的海拔。如果甲地海拔高于海平面 25m，记为 +25 m，那么乙地海拔低于海平面 12m 记为（　）</p>\",\"answerContent\":\"<p>B</p>\",\"analysisContent\":\"<p>【分析】本题考查了正负数的意义，以海平面为基准，高于海平面记为正数，低于海平面记为负数，据此即可求解．</p><p>【详解】解：∵甲地高于海平面25m记为<span data-latex=\\\"+\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span><span data-latex=\\\"25\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span><span data-latex=\\\"m\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>，</p><p><span data-latex=\\\"\\\\therefore\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>乙地低于海平面12m应记为<span data-latex=\\\"-\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span><span data-latex=\\\"12\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span><span data-latex=\\\"m\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>。</p><p><span data-latex=\\\"\\\\therefore\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>故选：<span data-latex=\\\"B\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span></p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>+12m</p>\"},{\"label\":\"B\",\"value\":\"<p>-12m</p>\"},{\"label\":\"C\",\"value\":\"<p>+13m</p>\"},{\"label\":\"D\",\"value\":\"<p>+37m</p>\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-10 11:21:28",
                    "updateTime": "2026-09-17 14:00:59",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 1
                },
                {
                    "id": 128,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "select",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "match",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>2025年“赣超”足球联赛火了，为了清晰统计球队的净胜球情况，赛事方规定：球队进球数超出失球数的部分记作正数，进球数少于失球数的部分记作负数．某赣超球队在一场关键比赛后，若“净胜球为+3”表示进球数比失球数多3个，那么进球数比失球数少2个应记作（&nbsp;&nbsp;&nbsp;）</p><p></p>\",\"answerContent\":\"<p>A</p>\",\"analysisContent\":\"<p>【分析】此题考查相反意义的量，根据净胜球的规定，进球数少于失球数记作负数，因此少2个应记作-2</p><p>【详解】∵进球数比失球数少2个，且规定进球数少于失球数的部分记作负数，∴应记作-2，</p><p>故选：A</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>-2</p>\"},{\"label\":\"B\",\"value\":\"<p>2</p>\"},{\"label\":\"C\",\"value\":\"<p>-1</p>\"},{\"label\":\"D\",\"value\":\"<p>1</p>\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-10 14:45:20",
                    "updateTime": "2026-09-17 11:27:38",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 2
                },
                {
                    "id": 131,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "select",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "match",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>人的正常体温是37℃左右(口腔温度). 如果以37℃为基准，用正数表示高于37℃的部分，用负数表示低于37℃的部分，那么38℃应该记作（　　）</p>\",\"answerContent\":\"<p>B</p>\",\"analysisContent\":\"<p>【分析】本题考查了正负数的运用，掌握正负表示相反意义的量是关键．以37℃为基准，高于部分记为正数，低于记为负数，38℃高于37℃，故记为正数，且差值为1℃．</p><p>【详解】解：基准温度为37℃，38℃＞37℃，<br>∴应记为正数，且超出部分为38℃-37℃=1℃，<br>∴记作+1℃，故选：B。</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>-1℃　</p>\"},{\"label\":\"B\",\"value\":\"<p>+1℃</p>\"},{\"label\":\"C\",\"value\":\"<p>-38℃</p><p></p>\"},{\"label\":\"D\",\"value\":\"<p>+38℃</p>\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-10 14:52:11",
                    "updateTime": "2026-09-17 11:25:39",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 3
                },
                {
                    "id": 133,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "select",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "match",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>受台风“博罗依”影响，某市大部分地区出现强降雨，该地区某水库发生建成以来最大洪水。水库水位快速升高，逼近防洪高水位。如果水位上升5m，记作+5m，那么水位下降3m，应记作（　　）</p>\",\"answerContent\":\"<p>D</p>\",\"analysisContent\":\"<p>【分析】本题主要考查了正负数的应用，根据“正负数表示相反意义的量”，上升记为正，则下降记为负即可得出答案．</p><p>【详解】解：∵水位上升5M记作+5M，∴水位下降3M应记作-3M．故选：D．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"<p>+3m</p>\"},{\"label\":\"B\",\"value\":\"<p>+2m　</p>\"},{\"label\":\"C\",\"value\":\"<p>-2m</p>\"},{\"label\":\"D\",\"value\":\"<p>-3m</p>\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-10 14:55:27",
                    "updateTime": "2026-09-17 11:25:10",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 4
                },
                {
                    "id": 81,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "match",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>一位病人每天下午需要测量一次血压，星期一下午测得的收缩压为160单位，之后连续4天的收缩压数值与前一天相比如下（上升为正，下降为负）：-30单位，+20单位，-18单位，+19单位。则该病人星期五的收缩压为_______单位。</p>\",\"answerContent\":\"<p>151</p>\",\"analysisContent\":\"<p>【分析】本题主要考查了正负数的实际应用，有理数的加减运算，解题的关键是掌握以上性质和运算法则．</p><p>根据正负数的实际应用，将每天的数据列出算式求出结果即可．</p><p>【详解】解：星期二的收缩压为：<span data-latex=\\\"160-30=130\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>（单位）；</p><p>星期三的收缩压为：<span data-latex=\\\"130+20=150\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>（单位）；</p><p>星期四的收缩压为：<span data-latex=\\\"150-18=132\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>（单位）；</p><p>星期五的收缩压为：<span data-latex=\\\"132+19=151\\\" class=\\\"math-node\\\" data-type=\\\"math\\\"></span>(单位）；</p><p>故答案为：151．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-10 10:22:13",
                    "updateTime": "2026-09-17 14:03:54",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 1
                },
                {
                    "id": 85,
                    "tenantId": "000000",
                    "isStagePaper": 0,
                    "grade": "seven",
                    "subject": "math",
                    "semester": "first",
                    "educationStage": "junior_high",
                    "type": "fill_blank",
                    "learningGrade": "A",
                    "learningForce": 0,
                    "module": "match",
                    "difficulty": "1",
                    "questionDetail": "{\"questionContent\":\"<p>“一带一路”沿线国家中的俄罗斯，2020年1月的日均最高气温是零下10℃，可记作_______℃。</p>\",\"answerContent\":\"<p>-10</p>\",\"analysisContent\":\"<p>【分析】本题考查了正负数的定义，解题关键是掌握正负数的定义并能运用求解．根据零下温度用负数表示．</p><p>【详解】解：2020年1月的日均最高气温是零下10℃，可记作-10℃，</p><p>故答案为：-10．</p>\",\"options\":[{\"label\":\"A\",\"value\":\"\"},{\"label\":\"B\",\"value\":\"\"},{\"label\":\"C\",\"value\":\"\"},{\"label\":\"D\",\"value\":\"\"}]}",
                    "questionDetailJson": null,
                    "status": "0",
                    "textbook": 2,
                    "textbookName": null,
                    "remark": null,
                    "createTime": "2026-02-10 10:35:51",
                    "updateTime": "2026-09-17 14:03:22",
                    "isCanDelete": null,
                    "createName": null,
                    "sortNo": 2
                }
            ],
            "printResult": "试卷打印成功",
            "learningForce": 0,
            "studentInfo": null
        }
    ]
}